import React from "react";
import { useTranslation } from "next-i18next";
import styles from "./style.module.scss";

const digitalProducts = [
    { key: "scientific_works", img: "📚" },
    { key: "models_3d", img: "🏠" },
    { key: "design_templates", img: "🎨" },
    { key: "websites", img: "💻" },
    { key: "templates", img: "📂" },
    { key: "video_lessons", img: "🎬" },
];

const freeLanceServices = [
    { key: "academic_services", img: "📚" },
    { key: "design", img: "🎨" },
    { key: "models_3d", img: "🏠" },
    { key: "programming_services", img: "💻" },
];

const SoffTypes = () => {
    const { t } = useTranslation("common");

    return (
        <section id="types" className={styles.soffTypes}>
            <h1 className={styles.sectionTitle}>
                {t("types.section_title")}
            </h1>

            <div className={styles.block}>
                <div className={styles.blockHeader}>
                    <h3>1</h3>
                    <h2>{t("types.product_block.title")}</h2>
                </div>
                <div className={styles.blockContent}>
                    <div className={styles.grid}>
                        {digitalProducts.map((item, idx) => (
                            <div className={styles.itemCard} key={idx}>
                                <div>
                                    <span style={{ fontSize: "25px" }}>{item.img}</span>
                                </div>
                                <p>{t(`types.product_block.items.${item.key}`)}</p>
                            </div>
                        ))}
                    </div>
                    <div className={styles.itemsList}>
                        <div className={styles.item}>
                            <img src={"/static/svgs/shieldIcon.svg"} alt="shield" />
                            <p>{t("types.product_block.notes.marketing")}</p>
                        </div>
                        <div className={styles.item}>
                            <img src={"/static/svgs/coinIcon.svg"} alt="coin" />
                            <p>{t("types.product_block.notes.payout")}</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Divider */}
            <div className={styles.divider}></div>

            {/* Xizmat ko‘rsatish */}
            <div style={{ marginBottom: "120px" }} className={styles.block}>
                <div className={styles.blockHeader}>
                    <h3>2</h3>
                    <h2>{t("types.service_block.title")}</h2>
                </div>
                <div className={styles.blockContent}>
                    <div className={styles.grid}>
                        {freeLanceServices.map((item, idx) => (
                            <div className={styles.itemCard} key={idx}>
                                <div>
                                    <span style={{ fontSize: "25px" }}>{item.img}</span>
                                </div>
                                <p>{t(`types.service_block.items.${item.key}`)}</p>
                            </div>
                        ))}
                    </div>
                    <div className={styles.itemsList}>
                        <div className={styles.item}>
                            <img src={"/static/img/HomePage/shield.png"} alt="shield" />
                            <p>{t("types.service_block.notes.order")}</p>
                        </div>
                        <div className={styles.item}>
                            <img src={"/static/img/HomePage/coin.png"} alt="coin" />
                            <p>{t("types.service_block.notes.payout")}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SoffTypes;
